import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  const fieldMaxWidth = 320;

  return createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: fieldMaxWidth
    },
    formControl2: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    marginLeft: {
      marginLeft: theme.spacing(1)
    },
    ageRuleBtn: {
      maxWidth: 130,
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    },
    dialog: {
      overflow: 'hidden'
    },
    updateForm: {
      minWidth: 250,
      justifyContent: 'center'
    }
  });
});
